import Button from '../../../../../component/ui/Button';
import { getDate } from '../../../../../utils/dateUtils';
import { numberToWords } from '../../../../../utils/helper';
import PaymentReceivedDetailTable from './paymentReceivedDetailTable';

const PaymentReceivedPdfView = ({
	prDetails,
	setIsDrawerOpen,
	setDrawerType,
	setIsSalesDrawerOpen,
	setInvoiceId,
}) => {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<div
				style={{
					overflowY: 'auto',
					flex: 1,
					padding: '50px 0',
				}}
			>
				<div
					style={{
						maxWidth: '750px',
						margin: '19px auto',
						minHeight: '600px',
						backgroundColor: '#fff',
						padding: '20px',
						boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
					}}
				>
					{/* Store Details */}
					<div style={{ border: '1px solid #555B67', padding: '12px' }}>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div style={{ marginBottom: '20px' }}>
								<h4 style={{ marginBottom: '13px', fontWeight: 'bold', fontSize: '22px' }}>
									{prDetails?.organisation?.organisation_name}
								</h4>
								<p style={{ color: '#555B67', fontSize: '14px' }}>
									{prDetails?.organisation?.address?.state?.name || 'N/A'}
								</p>
								<p style={{ color: '#555B67', fontSize: '14px' }}>
									{prDetails?.organisation?.address?.country?.name || 'N/A'}
								</p>
							</div>
						</div>

						{/* Payment Info */}

						<h5
							style={{
								margin: '8px 250px 28px 270px',
								fontWeight: '600',
								borderBottom: '1px solid black',
								fontSize: '20px',
								textAlign: 'center',
								maxWidth: '165px',
								paddingBottom: '5px',
							}}
						>
							Payment Receipt
						</h5>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'flex-start',
								marginBottom: '20px',
							}}
						>
							<div>
								<div className="d-flex">
									<div style={{ marginTop: '5px', color: '#555B67' }}>
										<p style={{ marginBottom: '16px' }}>Payment#</p>
										<p style={{ marginBottom: '16px' }}>Payment Date</p>
										<p style={{ marginBottom: '16px' }}>Reference Number</p>
										<p style={{ marginBottom: '16px' }}>Payment Mode</p>
										<p style={{ marginBottom: '16px' }}>Amount Received In Words</p>
									</div>
									<div style={{ width: '270px', marginLeft: '35px', fontWeight: 'bold' }}>
										<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '20px' }}>
											{prDetails?.payment_receive_number}
										</p>
										<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
											{getDate(prDetails?.date)}
										</p>
										<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
											{prDetails?.notes || 'N/A'}
										</p>
										<p style={{ borderBottom: '1px solid #E5E6E8', marginBottom: '15px' }}>
											{prDetails?.payment_mode?.payment_method_name || 'N/A'}
										</p>
										<p style={{ borderBottom: '1px solid #E5E6E8' }}>
											{numberToWords(Number(prDetails?.cash_handed || 0).toFixed(2))}
										</p>
									</div>
								</div>
							</div>

							<div
								style={{
									backgroundColor: '#84AD5F',
									width: '170px',
									height: '110px',
									marginTop: '18px',
									color: 'white',
									textAlign: 'center',
								}}
							>
								<div style={{ marginTop: '32px' }}>
									<p>Amount Recieved</p>
									<p style={{ fontSize: '14px', fontWeight: '600' }}>
										{'Rs. '}
										{Number(prDetails?.cash_handed).toFixed(2)}
									</p>
								</div>
							</div>
						</div>

						{/* Paid To */}
						<div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between' }}>
							<div>
								<p style={{ fontWeight: 'bold', margin: 0 }}>Bill To</p>
								<a
									href="#"
									onClick={() => {
										setDrawerType('customer');
										setIsDrawerOpen(true);
										setIsSalesDrawerOpen(false);
									}}
									style={{ color: '#3B58FF', textDecoration: 'none', fontWeight: 'bold' }}
								>
									{prDetails?.customer?.name}
								</a>
							</div>
							<div>
								<p style={{ fontWeight: '6000', margin: 0 }}>Authorized Signature</p>
							</div>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0px' }}>
							<div style={{ fontWeight: '600', margin: 0, fontSize: '14px', color: '#00000' }}>
								Payment For
							</div>
							{prDetails && Number(prDetails.excess_payment_amount) > 0 && (
								<div style={{ fontWeight: '600', fontSize: '14px', color: '#F51717', margin: 0 }}>
									Excess/Unused amount: ₹ {Number(prDetails.excess_payment_amount).toFixed(2)}
								</div>
							)}
						</div>
						{/* Table */}
						<PaymentReceivedDetailTable
							setIsSalesDrawerOpen={setIsSalesDrawerOpen}
							setIsDrawerOpen={setIsDrawerOpen}
							setInvoiceId={setInvoiceId}
							tableColumns={['INVOICE NUMBER', 'INVOICE DATE', 'INVOICE AMOUNT', 'PAYMENT AMOUNT']}
							tableRows={
								prDetails && prDetails?.sales_payment_receives_invoices?.length > 0
									? prDetails?.sales_payment_receives_invoices.map((pr) => {
										return {
											invoice_id: pr?.invoice?.id,
											invoice_number: pr?.invoice?.invoice_number,
											invoice_date: pr?.invoice?.date,
											invoice_amount: pr?.invoice_amount,
											payment_amount: pr?.invoice_payment_amount,
										};
									})
									: []
							}
							type={'pm'}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
export default PaymentReceivedPdfView;
